import { useParams } from "react-router-dom";
import blog1Data from "./blog1Data";
import blog2Data from "./blog2Data";
import blog3Data from "./blog3Data";
import blog4Data from "./blog4Data";
import MarketingSection from "./MarketingSection";
import Navbar from "./BlogNavbar";

const blogs = [blog1Data, blog2Data, blog3Data, blog4Data];

export default function BlogPostPage() {
  const { id } = useParams();
  const blog = blogs.find((b) => b?.id?.toString() === id);

  return (
    <>
      <Navbar />
      {blog ? (
        <MarketingSection {...blog} />
      ) : (
        <div className="not-found-container">
          <div className="not-found-card">
            <h1 className="not-found-title">404</h1>
            <p className="not-found-message">Blog post not found.</p>
            <a href="/" className="not-found-button">
              Back to Home
            </a>
          </div>
        </div>
      )}
    </>
  );
}
